module.exports = {
  cookie_1: 'Diese Website verwendet Cookies, um Ihre Erfahrung zu personalisieren. Details finden Sie in unseren',
  cookie_2: 'Durch die Nutzung unserer Website und die Zustimmung zu dieser Richtlinie, willigen Sie der Verwendung von Cookies zu',
  cookiePrivacy: 'Datenschutz- und Cookie Richtlinie',
  tearmsConditions: 'Allgemeine Geschäftsbedingungen',
  accept: 'Bestätigen',
  register: 'Registrieren',
  login: 'Anmelden',
  logout: 'Abmelden',
  history: 'Historie',
  settings: 'Einstellungen',
  notActive: 'Sehr geehrte Kundin sehr geehrter Kunde, dieser Webshop ist aktuell nicht aktiviert.',
  failLogOut: 'Abmeldung fehlgeschlagen',
  logOut: 'Sie sind nun abgemeldet',
  iAgree1: 'Hiermit stimme ich den',
  iAgree2: 'zu',
  and: 'sowie der',
  adminPanel: 'Admin Panel',
  besuche: 'Besuche',
  rateUs: 'Bitte bewerten Sie uns',
  rateHint: 'Sagen Sie uns ihre Meinung',
  orders: 'Bestellungen',
  customer: 'Kunde',
  deliveryTime: 'Lieferzeit',
  rating: 'Bewertung',
  value: 'Wert',
};



// WEBPACK FOOTER //
// ./src/lang/de/header.js